import { AlmanacFile as FileType } from 'types'

export enum TreeItemType {
  Article = 'article',
  Channel = 'channel',
  Project = 'folder',
  MediaFile = 'media_file',
  Design = 'design',
  /**
   * This is used to reference Legacy handbooks (handbooks without folders)
   */
  Handbook = 'handbook',
}

export interface ParentClientProp {
  loadMore: any
  hasMore?: boolean
}

export type TreeDataItem = Pick<
  FileType,
  | 'id'
  | 'children'
  | 'real_workspace_id'
  | 'title'
  | 'header_emoji'
  | 'parent_id'
  | 'handbook'
  | 'mention_id'
  | 'external_file_icon'
  | 'default_project'
  | 'ancestor_projects'
  | 'has_edit_access'
  | 'handbook_mode'
  | 'database_mode'
  | 'has_subprojects'
  | 'is_template'
  | 'is_root'
  | 'default_view'
  | 'has_descendant_articles'
  | 'channel'
  | 'channel_emoji'
> & {
  file_id?: string | number | null
  type: TreeItemType
  slug?: string
  isLast?: boolean
  parentClient?: ParentClientProp
  new?: boolean
  position?: number
  is_template?: boolean
  community_template_id?: number
}
